"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestScriptSetup = void 0;
/**
 * A structured set of tests against a FHIR server or client implementation to determine compliance against the FHIR specification.
 */
var TestScriptSetup = /** @class */ (function () {
    function TestScriptSetup() {
    }
    return TestScriptSetup;
}());
exports.TestScriptSetup = TestScriptSetup;
